<template>
  <v-container>
    <!-- Header da página -->
    <div class="mb-6">
      <p class="title ma-0">Resumo da Campanha</p>
    </div>

    <!-- Card da Campanha -->
    <v-card outlined class="mb-6">
      <div style="background: linear-gradient(to right, #0c2646, #2a5788); padding: 14px 20px; border-radius: 3px 3px 0 0">
        <p class="title font-weight-bold white--text ma-0">{{ getCampanha.nome_campanha }}</p>
      </div>
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 1px; background: rgba(0,0,0,0.12)">
        <div style="padding: 12px 16px; background: white">
          <p class="caption grey--text ma-0">Custo Estimado</p>
          <p class="body-2 font-weight-bold ma-0 mt-1">{{ totalCustoEstimado }}</p>
        </div>
        <div style="padding: 12px 16px; background: white">
          <p class="caption grey--text ma-0">Fechamento</p>
          <p class="body-2 font-weight-bold ma-0 mt-1">{{ getCampanha.tipo_dado || "—" }}</p>
        </div>
        <div style="padding: 12px 16px; background: white">
          <p class="caption grey--text ma-0">Crescimento</p>
          <p class="body-2 font-weight-bold ma-0 mt-1">{{ crescimentoDisplay }}</p>
        </div>
        <div style="padding: 12px 16px; background: white">
          <p class="caption grey--text ma-0">Período</p>
          <p class="body-2 font-weight-bold ma-0 mt-1">
            {{ getCampanha.data_inicio | BrazilianStandardDate }}
            <span class="grey--text font-weight-regular"> — </span>
            {{ getCampanha.data_final | BrazilianStandardDate }}
          </p>
        </div>
      </div>
      <div v-if="getCampanha.objetivo_campanha" style="padding: 12px 16px; border-top: 1px solid rgba(0,0,0,0.12); background: rgba(0,0,0,0.02)">
        <p class="caption font-weight-bold text-uppercase grey--text ma-0 mb-1" style="letter-spacing: 0.06em">Objetivo</p>
        <p class="body-2 ma-0" style="white-space: pre-line">{{ getCampanha.objetivo_campanha }}</p>
      </div>
    </v-card>

    <!-- Empresas -->
    <v-card outlined class="mb-6">
      <div style="padding: 10px 16px; background: linear-gradient(to right, #0c2646, #2a5788)">
        <p class="caption font-weight-bold text-uppercase white--text ma-0" style="letter-spacing: 0.06em">
          Empresas
          <span style="color: rgba(255,255,255,0.7)">({{ getEmpresasParticipantes.length }})</span>
        </p>
      </div>
      <div v-if="getLoadingState" class="d-flex justify-center py-4">
        <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
      </div>
      <template v-else>
        <div style="display: grid; grid-template-columns: auto 1fr 1fr; padding: 6px 16px; background: #eeeeee; border-bottom: 1px solid rgba(0,0,0,0.12)">
          <p class="caption font-weight-medium grey--text text--darken-2 ma-0 mr-4">Band.</p>
          <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Apelido</p>
          <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Empresa</p>
        </div>
        <div
          v-for="empresa in getEmpresasParticipantes"
          :key="empresa.cnpj || empresa.id_empresa_campanha"
          style="display: grid; grid-template-columns: auto 1fr 1fr; align-items: center; padding: 8px 16px; border-bottom: 1px solid rgba(0,0,0,0.06)"
        >
          <BaseSegmento :segmento="empresa.id_band" class="mr-4" />
          <span class="caption font-weight-medium" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ empresa.apelido }}</span>
          <span class="caption grey--text text--darken-1" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ formatNomeEmpresa(empresa.nome_empresa) }}</span>
        </div>
      </template>
    </v-card>

    <!-- Público x Meta -->
    <v-card outlined class="mb-6">
      <div style="padding: 10px 16px; background: linear-gradient(to right, #0c2646, #2a5788)">
        <p class="caption font-weight-bold text-uppercase white--text ma-0" style="letter-spacing: 0.06em">
          Público x Meta
          <span style="color: rgba(255,255,255,0.7)">({{ nMetasTotal }})</span>
        </p>
      </div>
      <div v-if="loadingMetas" class="d-flex justify-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <p v-else-if="metasFlat.length === 0" class="body-2 grey--text text-center py-6 ma-0">
        Nenhuma meta cadastrada.
      </p>
      <div v-else style="padding: 16px; display: flex; flex-direction: column; gap: 12px">
        <ListaCardMetas
          :metas="metasFlat"
          :campanha="getCampanha"
          :array-fechamentos-semanal="arrayFechamentosSemanal"
          :metas-colaborador="metasColaborador"
          :on-edite="false"
        />
      </div>
    </v-card>

    <!-- Ação -->
    <div v-if="onEdite" class="d-flex justify-end mt-4 mb-6">
      <v-btn color="success" large @click="confirmaCadastroCampanha()">
        <v-icon left>mdi-check</v-icon>
        Confirmar Cadastro
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import campanhas from "@/services/http/campanhaService";
import comissao from "@/services/http/comissaoService";
import campanhaService from "@/services/campanha";
import { getApiError } from "@/services/http";
import dataMixins from "@/mixins/dateMixin";
import multiplicadorBonus from "@/utils/multiplicadorBonus";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ResumoCadastroCampanha",

  components: {
    BaseSegmento: () => import("@/components/shared/BaseSegmento"),
    ListaCardMetas: () => import("@/components/campanha/cadastro/PublicoMeta/ListaCardMetas")
  },

  mixins: [dataMixins],

  props: {
    onEdite: { type: Boolean, default: true }
  },

  data() {
    return {
      metasFlat: [],
      // { id_campanha_meta: [{ id_colaborador, id_empresa, valor_meta,
      //   valor_media_referencia, meta_manual, valor_bonus }] } — vem ao lado
      // de `data` na resposta de metas-campanha, nao dentro das linhas.
      metasColaborador: {},
      loadingMetas: false,
      arrayFechamentosSemanal: [],
      percentualCrescimento: null
    };
  },

  computed: {
    ...mapGetters({
      getLoadingState: "campanha/getLoadingState",
      getEmpresasParticipantes: "campanha/getEmpresasParticipantes",
      getCampanha: "campanha/getCampanha"
    }),

    nMetasTotal() {
      const seen = new Set();
      for (const row of this.metasFlat) {
        if (row.id_campanha_meta) seen.add(row.id_campanha_meta);
      }
      return seen.size;
    },

    crescimentoDisplay() {
      // Prioriza o percentual do GMR vinculado; senão cai no da campanha.
      const val =
        this.percentualCrescimento != null && this.percentualCrescimento !== ""
          ? this.percentualCrescimento
          : this.getCampanha.perc_crescimento;
      return val != null && val !== "" ? `${val}%` : "—";
    },

    metaInfoMap() {
      const map = {};
      for (const row of this.metasFlat) {
        const id = row.id_campanha_meta;
        if (!id) continue;
        if (!map[id]) {
          map[id] = {
            colaboradores: [],
            indicadores: [], indicadoresRaw: [], faixasIndicador: [],
            chassi: [],
            modelos: [], modelosRaw: [], faixasModelo: [],
            pecas: [], pecasRaw: [], faixasPeca: [],
            servicos: [], servicosRaw: [], faixasServico: []
          };
        }
        const m = map[id];
        // Por (colaborador, EMPRESA): e assim que a meta grava. Deduplicar so
        // pelo nome contava quem atua em duas empresas da campanha como um, e
        // nColaboradores alimenta o custo estimado logo abaixo — o total sairia
        // menor do que a campanha vai pagar.
        if (row.colaborador && !m.colaboradores.some(c => c.nome === row.colaborador
                                                      && c.id_empresa == row.id_empresa))
          m.colaboradores.push({ nome: row.colaborador, id_empresa: row.id_empresa });
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo != 2 && row.id_indicador) {
          if (!m.indicadores.some(i => i.id_indicador == row.id_indicador))
            m.indicadores.push({ id_indicador: row.id_indicador, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_indicador}`;
            if (!m.indicadoresRaw.some(r => r._key === rk))
              m.indicadoresRaw.push({ _key: rk, colaborador: row.colaborador, id_indicador: row.id_indicador, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
          }
        }
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo == 2 && row.id_indicador && row.qtde_de != null) {
          const key = `${row.id_indicador}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasIndicador.some(f => f._key === key))
            m.faixasIndicador.push({ _key: key, id_indicador: row.id_indicador, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
        }
        if (row.id_tipo_conteudo == 2 && row.chassi_completo) {
          if (!m.chassi.some(c => c.chassi_completo === row.chassi_completo))
            m.chassi.push({ chassi_completo: row.chassi_completo, valor_bonus: row.valor_bonus });
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo != 2 && row.id_produto) {
          if (!m.modelos.some(p => p.id_produto == row.id_produto))
            m.modelos.push({ id_produto: row.id_produto, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_produto}`;
            if (!m.modelosRaw.some(r => r._key === rk))
              m.modelosRaw.push({ _key: rk, colaborador: row.colaborador, id_produto: row.id_produto, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo == 2 && row.id_produto && row.qtde_de != null) {
          const key = `${row.id_produto}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasModelo.some(f => f._key === key))
            m.faixasModelo.push({ _key: key, id_produto: row.id_produto, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo != 2 && row.id_peca) {
          if (!m.pecas.some(p => p.id_peca == row.id_peca))
            m.pecas.push({ id_peca: row.id_peca, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_peca}`;
            if (!m.pecasRaw.some(r => r._key === rk))
              m.pecasRaw.push({ _key: rk, colaborador: row.colaborador, id_peca: row.id_peca, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo == 2 && row.id_peca && row.qtde_de != null) {
          const key = `${row.id_peca}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasPeca.some(f => f._key === key))
            m.faixasPeca.push({ _key: key, id_peca: row.id_peca, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo != 2 && row.id_servico) {
          if (!m.servicos.some(p => p.id_servico == row.id_servico))
            m.servicos.push({ id_servico: row.id_servico, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_servico}`;
            if (!m.servicosRaw.some(r => r._key === rk))
              m.servicosRaw.push({ _key: rk, colaborador: row.colaborador, id_servico: row.id_servico, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo == 2 && row.id_servico && row.qtde_de != null) {
          const key = `${row.id_servico}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasServico.some(f => f._key === key))
            m.faixasServico.push({ _key: key, id_servico: row.id_servico, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
      }
      return map;
    },

    custoEstimadoValor() {
      const nSemanas = this.getCampanha.id_tipo_dado === "C" && this.arrayFechamentosSemanal.length > 0
        ? this.arrayFechamentosSemanal.length : 1;
      let total = 0;
      const seen = new Set();
      for (const row of this.metasFlat) {
        const id = row.id_campanha_meta;
        if (!id || seen.has(id)) continue;
        seen.add(id);
        total += this.calcularCustoMeta(row, this.metaInfoMap[id] || {}, nSemanas);
      }
      return total;
    },

    totalCustoEstimado() {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(this.custoEstimadoValor);
    }
  },

  methods: {
    ...mapActions({
      actionCampanha: "campanha/actionCampanha",
      actionEmpresasParticipantes: "campanha/actionEmpresasParticipantes"
    }),

    async carregarMetas() {
      this.loadingMetas = true;
      try {
        const res = await campanhas().metasCampanha().show({ id_campanha: this.$route.params.idCampanha, per_page: -1 });
        this.metasFlat = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
        // Irmao de `data` na resposta, uma entrada por participante. Sem ele o
        // ListaCardMetas nao tem como montar a secao da meta do participante e
        // ela some do resumo — mesmo padrao de SectionPublicoMeta.
        this.metasColaborador = (!Array.isArray(res?.data) && res?.data?.metas_colaborador) || {};
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao carregar metas") });
      } finally {
        this.loadingMetas = false;
      }
    },

    async carregarSemanasCampanha() {
      try {
        const d = this.getCampanha.data_inicio || "";
        const { data } = await comissao().tipoFechamento().show({
          id_tipo_dado: "C",
          id_tipo_evento: "M",
          mes_ref: d.substr(5, 2),
          ano_ref: d.substr(0, 4)
        });
        const semanas = data.data || [];
        semanas.sort((a, b) => new Date(a.data_final) - new Date(b.data_final));
        this.arrayFechamentosSemanal = semanas;
      } catch {
        // silently fail — custo calculado sem multiplicador semanal
      }
    },

    async carregarGmr() {
      try {
        const { data } = await campanhas()
          .metasCampanhaGmr()
          .show({ id_campanha: this.$route.params.idCampanha });
        const lista = Array.isArray(data) ? data : data.data || [];
        const gmr = lista[0];
        if (
          gmr &&
          (gmr.vincula === "S" || gmr.vincula === true || gmr.vincula === 1)
        ) {
          this.percentualCrescimento = gmr.percentual_gmr;
        }
      } catch {
        // sem GMR vinculado
      }
    },

    calcularCustoMeta(row, info, nSemanas = 1) {
      const tipoPagamento = Number(row.id_tipo_pagamento);
      const tipoCalculo = Number(row.id_tipo_calculo);
      const tipoConteudo = Number(row.id_tipo_conteudo);
      const nColaboradores = (info.colaboradores || []).length || 1;

      // Faixa progressiva — usa maior faixa como estimativa
      if (tipoCalculo === 2) {
        const faixasMap = {
          1: { faixas: info.faixasIndicador || [], idKey: 'id_indicador' },
          3: { faixas: info.faixasModelo    || [], idKey: 'id_produto' },
          4: { faixas: info.faixasPeca      || [], idKey: 'id_peca' },
          5: { faixas: info.faixasServico   || [], idKey: 'id_servico' }
        }[tipoConteudo];
        if (!faixasMap) return 0;
        const ids = [...new Set(faixasMap.faixas.map(f => f[faixasMap.idKey]))];
        let por = 0;
        ids.forEach(id => {
          const faixas = faixasMap.faixas.filter(f => f[faixasMap.idKey] == id).sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
          if (faixas.length)
            por +=
              multiplicadorBonus({
                tipoPagamento,
                tipoApuracao: faixas[0].tipo_apuracao,
                baseCalculo: faixas[0].base_calculo_indicador,
                quantidade: faixas[0].qtde_ate
              }) * (parseFloat(faixas[0].valor_bonus) || 0);
        });
        return por * nColaboradores * (tipoConteudo === 1 ? nSemanas : 1);
      }

      if (tipoConteudo === 2) {
        return (info.chassi || []).reduce((sum, c) => sum + (parseFloat(c.valor_bonus) || 0), 0);
      }

      if (tipoConteudo === 1) {
        const bonus = parseFloat(row.valor_bonus) || 0;
        if (tipoPagamento !== 1) return bonus * nColaboradores * nSemanas;
        // Por unidade: usa raw por colaborador para tratar metas individuais com
        // alvos distintos. O multiplicador e por INDICADOR - margem 'P' entra
        // com zero, quantidade com a meta.
        const mult = r =>
          multiplicadorBonus({
            tipoPagamento,
            tipoApuracao: r.tipo_apuracao,
            baseCalculo: r.base_calculo_indicador,
            quantidade: r.valor_meta
          });
        const rawRows = info.indicadoresRaw || [];
        if (rawRows.length > 0) {
          const colabs = [...new Set(rawRows.map(r => r.colaborador))];
          let total = 0;
          colabs.forEach(colab => {
            const rows = rawRows.filter(r => r.colaborador === colab);
            total += rows.reduce((s, r) => s + mult(r), 0) * bonus;
          });
          return total * nSemanas;
        }
        return (
          (info.indicadores || []).reduce((sum, ind) => sum + mult(ind), 0) *
          bonus *
          nColaboradores *
          nSemanas
        );
      }

      // Tipos 3, 4, 5 (Modelo, Peça, Serviço): usa raw por colaborador×item
      const rawMap = { 3: info.modelosRaw, 4: info.pecasRaw, 5: info.servicosRaw };
      const rawRows = rawMap[tipoConteudo] || [];
      if (rawRows.length > 0) {
        return rawRows.reduce(
          (s, r) =>
            s +
            multiplicadorBonus({ tipoPagamento, quantidade: r.valor_meta }) *
              (parseFloat(r.valor_bonus) || 0),
          0
        );
      }
      // Fallback: listas deduplicadas × nColaboradores
      const listMap = { 3: info.modelos, 4: info.pecas, 5: info.servicos };
      let por = 0;
      (listMap[tipoConteudo] || []).forEach(item => {
        por +=
          multiplicadorBonus({ tipoPagamento, quantidade: item.valor_meta }) *
          (parseFloat(item.valor_bonus) || 0);
      });
      return por * nColaboradores;
    },

    formatNomeEmpresa(nome) {
      return nome ? nome.split("-")[0].trim() : "";
    },

    async confirmaCadastroCampanha() {
      try {
        await this.$swal.confirm(
          "Ao confirmar o cadastro a campanha ficará disponível para aprovação. Ao ser aprovada não será possível sua edição!",
          "Confirmação de Cadastro",
          "Confirmar",
          "Cancelar"
        );
        await campanhaService.putCampanha(this.$route.params.idCampanha, {
          status: "S",
          valor_custo: this.custoEstimadoValor || 0,
          perc_crescimento: this.percentualCrescimento || 0
        });
        this.$router.push("/campanhas/consulta");
        this.$notify({ type: "success", text: "Campanha cadastrada com sucesso" });
      } catch (e) {
        if (e.response) {
          this.$notify({ type: "error", text: getApiError(e, "Não foi possível confirmar cadastro da campanha!") });
        }
      }
    }
  },

  async mounted() {
    await this.actionCampanha(this.$route.params.idCampanha);
    this.actionEmpresasParticipantes(this.$route.params.idCampanha);
    this.carregarMetas();
    this.carregarGmr();
    if (this.getCampanha.id_tipo_dado === "C") {
      this.carregarSemanasCampanha();
    }
  }
};
</script>
